export const BaseUrl = process.env.REACT_APP_FHIR_HOST;
export const AdalClientId = process.env.REACT_APP_ADAL_CLIENT_ID;
export const AdalTenantId = process.env.REACT_APP_ADAL_TENANT_ID;
export const AdalFhirId = process.env.REACT_APP_ADAL_FHIR_ID;

if (!BaseUrl) throw new Error('Fhir Host server not set');
export const DEFAULT_QUESTIONNAIRES = ['cristal', 'patient_values'];
